import React from "react";

import styled from "styled-components";

const Shift = styled.span`
  display: inline-block;
  svg {
    position: relative;
    top: 4px;
  }
`;

//super helpful resource!!!:  https://svg2jsx.com/
const SelectAllDays = ({ fill = "black", ...others }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...others}
  >
    <path
      d="M15 2.5V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5196 0.105357 14.2652 0 14 0C13.7348 0 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1V2.5H5V1C5 0.734784 4.89464 0.48043 4.70711 0.292893C4.51957 0.105357 4.26522 0 4 0C3.73478 0 3.48043 0.105357 3.29289 0.292893C3.10536 0.48043 3 0.734784 3 1V2.5H0V18C0 18.2652 0.105357 18.5196 0.292893 18.7071C0.48043 18.8946 0.734784 19 1 19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V2.5H15ZM16.5 17.5H1.5V7H16.5V17.5ZM15 16H3V8.5H15V16Z"
      fill={fill}
    />
  </svg>
);

const SelectWeek = ({ fill = "black", ...others }) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...others}
  >
    <path
      d="M15 2.5V1C15 0.734784 14.8946 0.48043 14.7071 0.292893C14.5196 0.105357 14.2652 0 14 0C13.7348 0 13.4804 0.105357 13.2929 0.292893C13.1054 0.48043 13 0.734784 13 1V2.5H5V1C5 0.734784 4.89464 0.48043 4.70711 0.292893C4.51957 0.105357 4.26522 0 4 0C3.73478 0 3.48043 0.105357 3.29289 0.292893C3.10536 0.48043 3 0.734784 3 1V2.5H0V18C0 18.2652 0.105357 18.5196 0.292893 18.7071C0.48043 18.8946 0.734784 19 1 19H17C17.2652 19 17.5196 18.8946 17.7071 18.7071C17.8946 18.5196 18 18.2652 18 18V2.5H15ZM16.5 17.5H1.5V7H16.5V17.5ZM15 12.5H3V8.5H15V12.5Z"
      fill={fill}
    />
  </svg>
);

const Hand = ({ fill = "black", ...others }) => (
  <Shift>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        d="M6.80473 5.26866C6.80473 5.26866 6.80473 3.29851 8.45414 3.29851C10.1035 3.29851 10.1035 5.26866 10.1035 5.26866V11.5075V2.97015C10.1035 2.97015 10.1036 1 11.753 1C13.4024 1 13.4024 2.97015 13.4024 2.97015V11.5075V4.28358C13.4024 4.28358 13.4024 2.31343 15.0518 2.31343C16.7012 2.31343 16.7012 4.28358 16.7012 4.28358V11.5075V5.59701C16.7012 5.59701 16.7012 3.62687 18.3506 3.62687C20 3.62687 20 5.59701 20 5.59701V11.5075C20 11.5075 20 13.806 20 16.4328C20 19.0597 18.6805 23 13.4024 23C8.12421 23 6.14492 20.3731 6.14492 20.3731L1.94137 16.1045C1.94137 16.1045 0.376926 15.1194 1.2816 13.806C2.18628 12.4925 3.50585 13.4776 3.50585 13.4776L6.80473 15.4478V5.26866Z"
        stroke={fill}
        strokeWidth="1.3"
        strokeLinejoin="round"
      />
    </svg>
  </Shift>
);

const AutoCreate = ({ fill = "black", ...others }) => (
  <Shift {...others}>
    <svg
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        maskType="alpha"
        maskUnits="userSpaceOnUse"
        x="8"
        y="0"
        width="15"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.88235 15C8.39504 15 8 14.605 8 14.1176L8 3.52941C8 3.0421 8.39504 2.64706 8.88235 2.64706L19.4706 2.64706C19.9579 2.64706 20.3529 3.0421 20.3529 3.52941L20.3529 14.1176C20.3529 14.605 19.9579 15 19.4706 15L8.88235 15ZM19.0294 13.6765L9.32353 13.6765L9.32353 3.97059L19.0294 3.97059L19.0294 13.6765Z"
          fill={fill}
        />
        <path
          d="M11.5294 7.39794e-07C11.0421 7.61095e-07 10.6471 0.395044 10.6471 0.882354L10.6471 1.32353L21.6765 1.32353L21.6765 12.3529L22.1176 12.3529C22.605 12.3529 23 11.9579 23 11.4706L23 0.882353C23 0.395044 22.605 2.55667e-07 22.1176 2.76968e-07L11.5294 7.39794e-07Z"
          fill={fill}
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M4.5 10.2114L19 4L13.5 17.5H25.5L26.5 -3L7.5 -5L4.5 10.2114Z"
          fill={fill}
        />
      </g>
      <path
        d="M14.5741 7.46029L14.7296 7.39352C14.8032 7.80006 15.1987 8.19646 15.6061 8.27084L15.5393 8.42551L1.621 14.3901L1.18402 14.2896C1.25163 14.1298 1.28375 13.943 1.26093 13.7317C1.24429 13.5562 1.18637 13.387 1.09189 13.2381L1.50267 13.0623L7.58407 14.4654L8.35576 14.6429L8.53411 15.4154L9.93718 21.4966L9.76138 21.9083C9.61495 21.8151 9.44886 21.7572 9.27622 21.7392C9.08405 21.715 8.88889 21.7412 8.70991 21.8153L8.60849 21.3783L14.5741 7.46029ZM9.42329 22.6968C9.23987 23.1237 9.0049 23.0958 8.89924 22.6385L7.29839 15.7011L0.360766 14.0994C-0.0981921 13.9937 -0.121013 13.7579 0.302445 13.5762L15.4903 7.06811C15.9172 6.8847 16.1141 7.08501 15.9324 7.50931L9.42329 22.6968Z"
        fill={fill}
      />
    </svg>
  </Shift>
);

const CopyCalendar = ({ fill = "black" }, ...others) => {
  return (
    <Shift {...others}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="28"
        fill="none"
        viewBox="0 0 33 28"
      >
        <path
          fill={fill}
          d="M7.512 11.783c.502 0 .902-.447.902-.999l7.22-.001c0 .265.094.52.264.708a.86.86 0 00.638.293.86.86 0 00.638-.293c.169-.187.264-.442.264-.707l2.256-.001v13H4.354v-13H6.61c0 .265.095.52.264.707a.86.86 0 00.638.293zm-3.617 13.5h16.257c.485 0 .895-.448.895-1.001V10.284c.001-.131-.021-.26-.066-.382a1.008 1.008 0 00-.193-.325.899.899 0 00-.291-.217.822.822 0 00-.345-.077h-2.714V8.282c0-.265-.095-.52-.264-.707a.86.86 0 00-.638-.293.86.86 0 00-.638.293c-.17.187-.265.442-.265.707v1.001H8.414V8.282c0-.265-.095-.52-.264-.707a.86.86 0 00-.638-.293.86.86 0 00-.638.293c-.17.187-.264.442-.264.707v1.001H3.895c-.484 0-.895.448-.895 1.001v13.998c0 .13.022.26.066.382.045.121.11.232.194.325a.898.898 0 00.291.217c.109.05.226.077.344.077z"
        ></path>
        <path
          fill={fill}
          d="M4 10.282h16.062v3.564H4v-3.564zM6 15.282h3.966v3.965H6v-3.965z"
        ></path>
        <mask
          id="a"
          width="24"
          height="24"
          maskType="alpha"
          x="7"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill={fill}
            d="M14.512 7.783c.502 0 .902-.447.902-.999l7.22-.001c0 .265.094.52.264.708a.86.86 0 00.638.293.86.86 0 00.638-.293c.169-.187.264-.442.264-.707l2.256-.001v13h-15.34v-13h2.256c0 .265.095.52.264.707a.86.86 0 00.638.293zm-3.617 13.5h16.257c.485 0 .895-.448.895-1.001V6.284c.001-.131-.021-.26-.066-.382a1.008 1.008 0 00-.193-.325.899.899 0 00-.291-.217.822.822 0 00-.345-.077h-2.714V4.282c0-.265-.095-.52-.264-.707a.86.86 0 00-.638-.293.86.86 0 00-.638.293c-.17.187-.265.442-.265.707v1.001h-7.219V4.282c0-.265-.095-.52-.264-.707a.86.86 0 00-.638-.293.86.86 0 00-.638.293c-.17.187-.264.442-.264.707v1.001h-2.715c-.484 0-.895.448-.895 1.001v13.998c0 .13.022.26.066.382.045.121.11.232.194.325a.897.897 0 00.291.217c.109.05.226.077.344.077z"
          ></path>
          <path
            fill={fill}
            d="M11 6.282h16.062v3.564H11V6.282zM13 11.282h3.965v3.966H13v-3.966z"
          ></path>
        </mask>
        <g mask="url(#a)">
          <path
            fill={fill}
            d="M9 8.5h5.5s0-2 2-2 2 2 2 2h1.75s1.75 0 1.75 2V23h6.5V2H9v6.5z"
          ></path>
        </g>
      </svg>
    </Shift>
  );
};

const NinetyLeft = ({ fill = "black" }, ...others) => {
  return (
    <Shift {...others}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 56 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M30 51C43.8071 51 55 39.8071 55 26C55 12.1929 43.8071 1 30 1C16.1929 1 5 12.1929 5 26"
          stroke={fill}
          strokeWidth="1.5"
        />
        <path
          d="M9.65649 22.3284L5.32812 26.6567L0.999756 22.3284"
          stroke={fill}
          strokeWidth="1.5"
        />
        <line
          x1="30.75"
          y1="48"
          x2="30.75"
          y2="54"
          stroke={fill}
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <path
          d="M27.4336 25.1797C27.4336 31.8828 24.8398 35.2344 19.6523 35.2344C18.7539 35.2344 18.0352 35.1562 17.4961 35V33.3242C18.1289 33.5273 18.8398 33.6289 19.6289 33.6289C21.5039 33.6289 22.918 33.0508 23.8711 31.8945C24.832 30.7305 25.3555 28.9492 25.4414 26.5508H25.3008C24.8711 27.207 24.3008 27.7031 23.5898 28.0391C22.8867 28.375 22.0859 28.543 21.1875 28.543C19.6719 28.543 18.4688 28.0898 17.5781 27.1836C16.6875 26.2852 16.2422 25.0195 16.2422 23.3867C16.2422 21.5977 16.7383 20.1914 17.7305 19.168C18.7227 18.1367 20.0352 17.6211 21.668 17.6211C22.543 17.6055 23.3359 17.7734 24.0469 18.125C24.7578 18.4688 25.3633 18.9688 25.8633 19.625C26.3711 20.2812 26.7617 21.0781 27.0352 22.0156C27.3086 22.9531 27.4414 24.0078 27.4336 25.1797ZM21.668 19.2852C21.1055 19.2852 20.6055 19.3789 20.168 19.5664C19.7383 19.7461 19.375 20.0117 19.0781 20.3633C18.7812 20.7148 18.5547 21.1445 18.3984 21.6523C18.2422 22.1523 18.1641 22.7227 18.1641 23.3633C18.1641 24.4883 18.4453 25.375 19.0078 26.0234C19.5703 26.6641 20.4258 26.9844 21.5742 26.9844C22.1055 27 22.6094 26.9219 23.0859 26.75C23.5625 26.5703 23.9766 26.332 24.3281 26.0352C24.6875 25.7305 24.9688 25.3867 25.1719 25.0039C25.375 24.6133 25.4727 24.2109 25.4648 23.7969C25.4727 23.1875 25.3828 22.6055 25.1953 22.0508C25.0078 21.4961 24.7422 21.0117 24.3984 20.5977C24.0625 20.1836 23.6602 19.8594 23.1914 19.625C22.7305 19.3828 22.2227 19.2695 21.668 19.2852ZM41.2617 26.4102C41.2617 29.3711 40.793 31.582 39.8555 33.043C38.9258 34.5039 37.5 35.2344 35.5781 35.2344C33.7344 35.2344 32.332 34.4883 31.3711 32.9961C30.4102 31.4961 29.9297 29.3008 29.9297 26.4102C29.9297 23.4258 30.3945 21.2109 31.3242 19.7656C32.2539 18.3203 33.6719 17.5977 35.5781 17.5977C37.4375 17.5977 38.8477 18.3516 39.8086 19.8594C40.7773 21.3672 41.2617 23.5508 41.2617 26.4102ZM31.8984 26.4102C31.8984 28.9102 32.1914 30.7266 32.7773 31.8594C33.3633 32.9922 34.2969 33.5586 35.5781 33.5586C36.875 33.5586 37.8125 32.9844 38.3906 31.8359C38.9766 30.6797 39.2695 28.8711 39.2695 26.4102C39.2695 23.9492 38.9766 22.1484 38.3906 21.0078C37.8125 19.8594 36.875 19.2852 35.5781 19.2852C34.2969 19.2852 33.3633 19.8516 32.7773 20.9844C32.1914 22.1094 31.8984 23.918 31.8984 26.4102Z"
          fill={fill}
        />
        <path
          d="M47.6104 20.29C47.6104 20.7295 47.5518 21.1234 47.4346 21.4717C47.3174 21.82 47.1481 22.1146 46.9268 22.3555C46.7087 22.5964 46.4401 22.7803 46.1211 22.9072C45.8021 23.0342 45.4424 23.0977 45.042 23.0977C44.6676 23.0977 44.3242 23.0342 44.0117 22.9072C43.6992 22.777 43.4307 22.5931 43.2061 22.3555C42.9814 22.1146 42.8073 21.8249 42.6836 21.4863C42.5599 21.1478 42.498 20.7686 42.498 20.3486C42.498 19.9059 42.5534 19.5088 42.6641 19.1572C42.7747 18.8024 42.9391 18.5029 43.1572 18.2588C43.3753 18.0146 43.6439 17.8275 43.9629 17.6973C44.2852 17.5671 44.6546 17.502 45.0713 17.502C45.4619 17.502 45.8135 17.5687 46.126 17.7021C46.4385 17.8324 46.7038 18.0195 46.9219 18.2637C47.1432 18.5046 47.3125 18.7975 47.4297 19.1426C47.5501 19.4844 47.6104 19.8669 47.6104 20.29ZM43.6797 20.29C43.6797 21.5368 44.1403 22.1602 45.0615 22.1602C45.973 22.1602 46.4287 21.5368 46.4287 20.29C46.4287 19.0563 45.9697 18.4395 45.0518 18.4395C44.57 18.4395 44.2201 18.599 44.002 18.918C43.7871 19.237 43.6797 19.6943 43.6797 20.29Z"
          fill={fill}
        />
      </svg>
    </Shift>
  );
};

const NinetyRight = ({ fill = "black" }, ...others) => {
  return (
    <Shift {...others}>
      <svg
        width="48"
        height="48"
        viewBox="0 0 56 54"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.4336 25.1797C21.4336 31.8828 18.8398 35.2344 13.6523 35.2344C12.7539 35.2344 12.0352 35.1562 11.4961 35V33.3242C12.1289 33.5273 12.8398 33.6289 13.6289 33.6289C15.5039 33.6289 16.918 33.0508 17.8711 31.8945C18.832 30.7305 19.3555 28.9492 19.4414 26.5508H19.3008C18.8711 27.207 18.3008 27.7031 17.5898 28.0391C16.8867 28.375 16.0859 28.543 15.1875 28.543C13.6719 28.543 12.4688 28.0898 11.5781 27.1836C10.6875 26.2852 10.2422 25.0195 10.2422 23.3867C10.2422 21.5977 10.7383 20.1914 11.7305 19.168C12.7227 18.1367 14.0352 17.6211 15.668 17.6211C16.543 17.6055 17.3359 17.7734 18.0469 18.125C18.7578 18.4688 19.3633 18.9688 19.8633 19.625C20.3711 20.2812 20.7617 21.0781 21.0352 22.0156C21.3086 22.9531 21.4414 24.0078 21.4336 25.1797ZM15.668 19.2852C15.1055 19.2852 14.6055 19.3789 14.168 19.5664C13.7383 19.7461 13.375 20.0117 13.0781 20.3633C12.7812 20.7148 12.5547 21.1445 12.3984 21.6523C12.2422 22.1523 12.1641 22.7227 12.1641 23.3633C12.1641 24.4883 12.4453 25.375 13.0078 26.0234C13.5703 26.6641 14.4258 26.9844 15.5742 26.9844C16.1055 27 16.6094 26.9219 17.0859 26.75C17.5625 26.5703 17.9766 26.332 18.3281 26.0352C18.6875 25.7305 18.9688 25.3867 19.1719 25.0039C19.375 24.6133 19.4727 24.2109 19.4648 23.7969C19.4727 23.1875 19.3828 22.6055 19.1953 22.0508C19.0078 21.4961 18.7422 21.0117 18.3984 20.5977C18.0625 20.1836 17.6602 19.8594 17.1914 19.625C16.7305 19.3828 16.2227 19.2695 15.668 19.2852ZM35.2617 26.4102C35.2617 29.3711 34.793 31.582 33.8555 33.043C32.9258 34.5039 31.5 35.2344 29.5781 35.2344C27.7344 35.2344 26.332 34.4883 25.3711 32.9961C24.4102 31.4961 23.9297 29.3008 23.9297 26.4102C23.9297 23.4258 24.3945 21.2109 25.3242 19.7656C26.2539 18.3203 27.6719 17.5977 29.5781 17.5977C31.4375 17.5977 32.8477 18.3516 33.8086 19.8594C34.7773 21.3672 35.2617 23.5508 35.2617 26.4102ZM25.8984 26.4102C25.8984 28.9102 26.1914 30.7266 26.7773 31.8594C27.3633 32.9922 28.2969 33.5586 29.5781 33.5586C30.875 33.5586 31.8125 32.9844 32.3906 31.8359C32.9766 30.6797 33.2695 28.8711 33.2695 26.4102C33.2695 23.9492 32.9766 22.1484 32.3906 21.0078C31.8125 19.8594 30.875 19.2852 29.5781 19.2852C28.2969 19.2852 27.3633 19.8516 26.7773 20.9844C26.1914 22.1094 25.8984 23.918 25.8984 26.4102Z"
          fill={fill}
        />
        <path
          d="M41.6104 20.29C41.6104 20.7295 41.5518 21.1234 41.4346 21.4717C41.3174 21.82 41.1481 22.1146 40.9268 22.3555C40.7087 22.5964 40.4401 22.7803 40.1211 22.9072C39.8021 23.0342 39.4424 23.0977 39.042 23.0977C38.6676 23.0977 38.3242 23.0342 38.0117 22.9072C37.6992 22.777 37.4307 22.5931 37.2061 22.3555C36.9814 22.1146 36.8073 21.8249 36.6836 21.4863C36.5599 21.1478 36.498 20.7686 36.498 20.3486C36.498 19.9059 36.5534 19.5088 36.6641 19.1572C36.7747 18.8024 36.9391 18.5029 37.1572 18.2588C37.3753 18.0146 37.6439 17.8275 37.9629 17.6973C38.2852 17.5671 38.6546 17.502 39.0713 17.502C39.4619 17.502 39.8135 17.5687 40.126 17.7021C40.4385 17.8324 40.7038 18.0195 40.9219 18.2637C41.1432 18.5046 41.3125 18.7975 41.4297 19.1426C41.5501 19.4844 41.6104 19.8669 41.6104 20.29ZM37.6797 20.29C37.6797 21.5368 38.1403 22.1602 39.0615 22.1602C39.973 22.1602 40.4287 21.5368 40.4287 20.29C40.4287 19.0563 39.9697 18.4395 39.0518 18.4395C38.57 18.4395 38.2201 18.599 38.002 18.918C37.7871 19.237 37.6797 19.6943 37.6797 20.29Z"
          fill={fill}
        />
        <path
          d="M26 51C12.1929 51 1 39.8071 1 26C1 12.1929 12.1929 1 26 1C39.8071 1 51 12.1929 51 26"
          stroke={fill}
          strokeWidth="1.5"
        />
        <path
          d="M46.3435 22.3284L50.6719 26.6567L55.0002 22.3284"
          stroke={fill}
          strokeWidth="1.5"
        />
        <line
          y1="-0.75"
          x2="6"
          y2="-0.75"
          transform="matrix(4.37112e-08 1 1 -4.37112e-08 26 48)"
          stroke={fill}
          strokeWidth="1.5"
        />
      </svg>
    </Shift>
  );
};

const AvailabilityCalendar = ({ fill = "black" }, ...others) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...others}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5893 10.25C11.3943 10.25 9.6093 12.036 9.6093 14.23C9.6093 16.424 11.3943 18.21 13.5893 18.21C15.7833 18.21 17.5693 16.424 17.5693 14.23C17.5693 12.036 15.7833 10.25 13.5893 10.25ZM13.5893 19.71C10.5673 19.71 8.1093 17.251 8.1093 14.23C8.1093 11.208 10.5673 8.75 13.5893 8.75C16.6103 8.75 19.0693 11.208 19.0693 14.23C19.0693 17.251 16.6103 19.71 13.5893 19.71Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7304 16.9326C12.7204 16.9326 12.7104 16.9326 12.7014 16.9326C12.4804 16.9236 12.2754 16.8186 12.1404 16.6456L10.8914 15.0526C10.6354 14.7266 10.6924 14.2556 11.0184 13.9996C11.3444 13.7446 11.8154 13.8016 12.0714 14.1266L12.7754 15.0246L15.1444 12.4486C15.4254 12.1426 15.9004 12.1246 16.2044 12.4036C16.5094 12.6836 16.5294 13.1586 16.2494 13.4626L13.2824 16.6896C13.1404 16.8456 12.9394 16.9326 12.7304 16.9326Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.865 19H17.007C17.555 19 18 18.552 18 17.999V17.267L15.865 19ZM9.865 17.5H1.5V7H16.5V10.048L18 11.454V2.5H15V1.009C15 0.443 14.552 0 14 0C13.444 0 13 0.452 13 1.009V2.5H5V1.009C5 0.443 4.552 0 4 0C3.444 0 3 0.452 3 1.009V2.5H0V17.999C0 18.555 0.445 19 0.993 19H11.482L9.865 17.5ZM16.147 17.5H16.5V17.236L16.147 17.5ZM3 12.5H7V8.5H3V12.5Z"
        fill={fill}
      />
    </svg>
  );
};

const WorldSearch = ({ fill = "black", ...others }) => {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...others}>
      <path d="M5.40804 3.30693L4.59935 2.54455C4.11799 2.61716 3.03974 2.87129 2.57763 3.30693C2.11553 3.74257 2 4.83168 2 5.32178L2.57763 5.81188L3.21303 5.92079L3.61737 6.62871L3.15527 8.26238L3.7329 9.18812V10.2772L5.92791 13L6.67883 12.8366L6.5633 10.3861C6.83286 10.1865 7.4413 9.73267 7.71857 9.51485C7.99583 9.29703 8.37322 8.5528 8.52725 8.20792L6.5633 6.5198L5.40804 7.06436H4.59935L4.19501 6.30198V5.64851L3.50185 4.50495V4.06931L5.40804 3.30693Z" fill={fill}/>
      <path d="M8.35396 2.54455C8.44639 2.3703 9.16265 2.10891 9.50923 2L9.91357 2.10891L10.9533 2.54455V2.92574L10.2602 2.9802L9.79805 3.36139L9.74028 4.06931H8.18067L7.48751 3.30693C7.73782 3.12541 8.26154 2.71881 8.35396 2.54455Z" fill={fill}/>
      <path d="M11.2421 4.83168L12.2241 4.28713C12.7247 4.61386 13.7606 5.39802 13.8992 5.92079C14.0725 6.57426 14.0148 8.31683 13.7837 9.35148C13.5989 10.1792 12.3974 11.33 11.8198 11.802L11.4154 11.6931V10.8762L12.2241 9.89604V8.86139L11.8198 8.53465L10.9533 9.02475L9.68252 8.31683L9.10489 6.62871L9.91357 4.83168H11.2421Z" fill={fill}/>
      <path d="M18.4612 17.0512L13.4612 12.0512C14.6158 10.539 15.1525 8.6444 14.9625 6.75127C14.7726 4.85814 13.8702 3.10795 12.4382 1.8552C11.0062 0.602443 9.15163 -0.0592382 7.25005 0.00417C5.34848 0.0675782 3.54207 0.851336 2.1967 2.1967C0.851336 3.54207 0.0675782 5.34848 0.00417 7.25005C-0.0592382 9.15163 0.602443 11.0062 1.8552 12.4382C3.10795 13.8702 4.85814 14.7726 6.75127 14.9625C8.6444 15.1525 10.539 14.6158 12.0512 13.4612L17.0512 18.4612C17.2425 18.6251 17.4886 18.7107 17.7403 18.7009C17.992 18.6912 18.2307 18.5869 18.4088 18.4088C18.5869 18.2307 18.6912 17.992 18.7009 17.7403C18.7107 17.4886 18.6251 17.2425 18.4612 17.0512ZM11.7412 11.7512C10.9019 12.5897 9.83275 13.1605 8.66904 13.3914C7.50534 13.6224 6.29928 13.5032 5.20331 13.0489C4.10735 12.5946 3.17067 11.8255 2.51167 10.839C1.85268 9.85241 1.50096 8.69264 1.50096 7.50624C1.50096 6.31983 1.85268 5.16006 2.51167 4.17351C3.17067 3.18696 4.10735 2.41792 5.20331 1.9636C6.29928 1.50928 7.50534 1.39007 8.66904 1.62104C9.83275 1.85201 10.9019 2.42279 11.7412 3.26124C12.2991 3.81847 12.7416 4.48021 13.0436 5.20859C13.3455 5.93698 13.501 6.71774 13.501 7.50624C13.501 8.29473 13.3455 9.07549 13.0436 9.80388C12.7416 10.5323 12.2991 11.194 11.7412 11.7512V11.7512Z" fill={fill}/>
    </svg>
  );
};
const AvailabilityManagement = ({fill = "black", ...others}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...others}>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5894 12.4099C14.3944 12.4099 12.6094 14.1959 12.6094 16.3899C12.6094 18.5839 14.3944 20.3699 16.5894 20.3699C18.7834 20.3699 20.5694 18.5839 20.5694 16.3899C20.5694 14.1959 18.7834 12.4099 16.5894 12.4099M16.5894 21.8699C13.5674 21.8699 11.1094 19.4109 11.1094 16.3899C11.1094 13.3679 13.5674 10.9099 16.5894 10.9099C19.6104 10.9099 22.0694 13.3679 22.0694 16.3899C22.0694 19.4109 19.6104 21.8699 16.5894 21.8699"
      fill={fill}/>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M15.7304 19.0927C15.7204 19.0927 15.7104 19.0927 15.7014 19.0927C15.4804 19.0837 15.2754 18.9787 15.1404 18.8057L13.8914 17.2127C13.6354 16.8867 13.6924 16.4157 14.0184 16.1597C14.3444 15.9047 14.8154 15.9617 15.0714 16.2867L15.7754 17.1847L18.1444 14.6087C18.4254 14.3027 18.9004 14.2847 19.2044 14.5637C19.5094 14.8437 19.5294 15.3187 19.2494 15.6227L16.2824 18.8497C16.1404 19.0057 15.9394 19.0927 15.7304 19.0927"
      fill={fill}/>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M18.865 21H20.007C20.555 21 21 20.552 21 19.999V19.267L18.865 21ZM12.865 19.5H4.5V6.27H19.5V12.048L21 13.454V9V6.001V4.5H18V3.009C18 2.443 17.552 2 17 2C16.444 2 16 2.452 16 3.009V4.5H8V3.009C8 2.443 7.552 2 7 2C6.444 2 6 2.452 6 3.009V4.5H3V6.001V9V19.999C3 20.555 3.445 21 3.993 21H14.482L12.865 19.5ZM19.147 19.5H19.5V19.236L19.147 19.5Z"
      fill={fill}/>
    <mask id="a123"
      maskUnits="userSpaceOnUse"
      maskType="alpha"
      x="3"
      y="2"
      width="19"
      height="19">
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0005 3.009V4.5H8.00049V3.009C8.00049 2.443 7.55249 2 7.00049 2V2C6.44449 2 6.00049 2.452 6.00049 3.009V3.009V4.5H3.00049V6.001V9V19.999C3.00049 20.555 3.44549 21 3.99349 21V21H14.4815L12.8645 19.5H4.50049V6.27H19.5005V12.047L21.0005 13.454V9V6.001V4.5H18.0005V3.009C18.0005 2.443 17.5525 2 17.0005 2V2C16.4445 2 16.0005 2.452 16.0005 3.009V3.009ZM19.1465 19.5H19.5005V19.236L19.1465 19.5ZM18.8655 21H20.0075C20.5555 21 21.0005 20.552 21.0005 19.999V19.999V19.267L18.8655 21Z"
        fill="white"/>
    </mask>
    <g mask="url(#a123)">
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M0.000488281 24H24.0005V0H0.000488281V24Z"
        fill={fill}/>
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M-1.99951 26H26.0005V-3H-1.99951V26Z"
        fill={fill}/>
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00049 17H21.0005V1H3.00049V17Z"
        fill={fill}/>
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M0.000488281 24H24.0005V0H0.000488281V24Z"
        fill={fill}/>
      <path fillRule="evenodd"
        clipRule="evenodd"
        d="M3.00049 17H21.0005V1H3.00049V17Z"
        fill={fill}/>
    </g>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8558 8.83276H6.14478C5.73078 8.83276 5.39478 8.49676 5.39478 8.08276C5.39478 7.66876 5.73078 7.33276 6.14478 7.33276H17.8558C18.2698 7.33276 18.6058 7.66876 18.6058 8.08276C18.6058 8.49676 18.2698 8.83276 17.8558 8.83276"
      fill={fill}/>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8558 11.6599H6.14478C5.73078 11.6599 5.39478 11.3239 5.39478 10.9099C5.39478 10.4959 5.73078 10.1599 6.14478 10.1599H17.8558C18.2698 10.1599 18.6058 10.4959 18.6058 10.9099C18.6058 11.3239 18.2698 11.6599 17.8558 11.6599"
      fill={fill}/>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M12.6088 14.5828H6.14478C5.73078 14.5828 5.39478 14.2468 5.39478 13.8328C5.39478 13.4188 5.73078 13.0828 6.14478 13.0828H12.6088C13.0228 13.0828 13.3588 13.4188 13.3588 13.8328C13.3588 14.2468 13.0228 14.5828 12.6088 14.5828"
      fill={fill}/>
    <path fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6488 17.4792H6.14478C5.73078 17.4792 5.39478 17.1432 5.39478 16.7292C5.39478 16.3152 5.73078 15.9792 6.14478 15.9792H11.6488C12.0628 15.9792 12.3988 16.3152 12.3988 16.7292C12.3988 17.1432 12.0628 17.4792 11.6488 17.4792"
      fill={fill}/>
  </svg>
)

const Selected = ({fill}) => (<svg style={{width: "24px", height: "24px"}} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="presentation">
  <path fill={fill} d="M4.5 19.5h15v-15h-15v15zM3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3zm5.395 12.683l-2.36-2.914a.755.755 0 0 0-1.061-.118.753.753 0 0 0-.105 1.062l2.82 3.482a.767.767 0 0 0 .235.195c.289.199.684.172.946-.08l8.215-7.933a.756.756 0 0 0 .019-1.061.748.748 0 0 0-1.061-.018l-7.648 7.385z"> </path>
</svg>)

const SelectedFilled = ({fill}) => (<svg style={{width: "24px", height: "24px"}} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="presentation"> <path fill={fill} d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007V3.993zm6.388 11.69l-2.36-2.914a.755.755 0 0 0-1.061-.118.753.753 0 0 0-.105 1.062l2.82 3.482a.767.767 0 0 0 .235.195c.289.199.684.172.946-.08l8.215-7.933a.756.756 0 0 0 .019-1.061.748.748 0 0 0-1.061-.018l-7.648 7.385z"> </path></svg>)

const IosShare = ({ primaryColor = '#01B6D1', secondaryColor = '#FC4E6D', ...others }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...others}>
      <path d="M3.23535 18.7642C2.36654 18.7642 1.71354 18.5483 1.27637 18.1167C0.844727 17.6906 0.628906 17.0487 0.628906 16.1909V7.90674C0.628906 7.04899 0.844727 6.40706 1.27637 5.98096C1.71354 5.54932 2.36654 5.3335 3.23535 5.3335H5.73389V6.66992H3.25195C2.83691 6.66992 2.51872 6.7806 2.29736 7.00195C2.07601 7.22331 1.96533 7.5498 1.96533 7.98145V16.1162C1.96533 16.5479 2.07601 16.8743 2.29736 17.0957C2.51872 17.3171 2.83691 17.4277 3.25195 17.4277H12.7314C13.141 17.4277 13.4591 17.3171 13.686 17.0957C13.9129 16.8743 14.0264 16.5479 14.0264 16.1162V7.98145C14.0264 7.5498 13.9129 7.22331 13.686 7.00195C13.4591 6.7806 13.141 6.66992 12.7314 6.66992H10.2578V5.3335H12.7563C13.6252 5.3335 14.2754 5.54932 14.707 5.98096C15.1442 6.4126 15.3628 7.05452 15.3628 7.90674V16.1909C15.3628 17.0431 15.1442 17.6851 14.707 18.1167C14.2754 18.5483 13.6252 18.7642 12.7563 18.7642H3.23535ZM7.9917 12.2646C7.81462 12.2646 7.65967 12.201 7.52686 12.0737C7.39958 11.9465 7.33594 11.7943 7.33594 11.6172V3.09229L7.38574 1.84717L6.82129 2.43652L5.56787 3.78125C5.45166 3.91406 5.29948 3.98047 5.11133 3.98047C4.93424 3.98047 4.79036 3.92513 4.67969 3.81445C4.56901 3.70378 4.51367 3.56266 4.51367 3.39111C4.51367 3.23617 4.57731 3.09229 4.70459 2.95947L7.51025 0.253418C7.5988 0.17041 7.67904 0.112305 7.75098 0.0791016C7.82845 0.0458984 7.90869 0.0292969 7.9917 0.0292969C8.08024 0.0292969 8.16048 0.0458984 8.23242 0.0791016C8.3099 0.112305 8.39014 0.17041 8.47314 0.253418L11.2788 2.95947C11.4116 3.09229 11.478 3.23617 11.478 3.39111C11.478 3.56266 11.4199 3.70378 11.3037 3.81445C11.1875 3.92513 11.0436 3.98047 10.8721 3.98047C10.6895 3.98047 10.54 3.91406 10.4238 3.78125L9.16211 2.43652L8.60596 1.84717L8.65576 3.09229V11.6172C8.65576 11.7943 8.58936 11.9465 8.45654 12.0737C8.32926 12.201 8.17432 12.2646 7.9917 12.2646Z" fill="black"/>
    </svg>
  );
};

const IosAddToHome = ({ primaryColor = '#01B6D1', secondaryColor = '#FC4E6D', ...others }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...others}>
      <path d="M18.5249 1.54834C18.868 1.8859 19.1253 2.27327 19.2969 2.71045C19.474 3.14209 19.5902 3.62354 19.6455 4.15479C19.7064 4.68604 19.7368 5.26986 19.7368 5.90625V14.1406C19.7368 14.777 19.7064 15.3608 19.6455 15.8921C19.5902 16.4233 19.474 16.9048 19.2969 17.3364C19.1253 17.7681 18.868 18.1554 18.5249 18.4985C18.1818 18.8416 17.7917 19.1017 17.3545 19.2788C16.9173 19.4559 16.4331 19.5749 15.9019 19.6357C15.3706 19.6966 14.7868 19.7271 14.1504 19.7271H5.84961C5.21322 19.7271 4.62939 19.6966 4.09814 19.6357C3.56689 19.5749 3.08268 19.4559 2.64551 19.2788C2.21387 19.1017 1.82373 18.8416 1.4751 18.4985C1.132 18.1554 0.874674 17.7681 0.703125 17.3364C0.531576 16.9048 0.415365 16.4233 0.354492 15.8921C0.29362 15.3608 0.263184 14.777 0.263184 14.1406V5.84814C0.263184 4.92952 0.337891 4.11328 0.487305 3.39941C0.636719 2.68001 0.96875 2.06576 1.4834 1.55664C1.99805 1.04199 2.61507 0.707194 3.33447 0.552246C4.05387 0.397298 4.87288 0.319824 5.7915 0.319824H14.1504C14.7868 0.319824 15.3706 0.35026 15.9019 0.411133C16.4331 0.472005 16.9173 0.590983 17.3545 0.768066C17.7917 0.94515 18.1818 1.20524 18.5249 1.54834ZM18.2676 5.61572C18.2676 5.007 18.2122 4.43978 18.1016 3.91406C17.9909 3.38281 17.7723 2.95394 17.4458 2.62744C17.1193 2.30094 16.6877 2.07959 16.1509 1.96338C15.6141 1.84717 15.0441 1.78906 14.4409 1.78906H5.60889C4.9891 1.78906 4.40527 1.84717 3.85742 1.96338C3.3151 2.07406 2.8807 2.29264 2.5542 2.61914C2.2277 2.94564 2.00911 3.38005 1.89844 3.92236C1.78776 4.45915 1.73242 5.0402 1.73242 5.66553V14.4312C1.73242 15.0343 1.78776 15.6016 1.89844 16.1328C2.00911 16.6641 2.2277 17.0929 2.5542 17.4194C2.8807 17.7459 3.31234 17.9673 3.84912 18.0835C4.3859 18.1997 4.95589 18.2578 5.55908 18.2578H14.4409C15.0441 18.2578 15.6141 18.1997 16.1509 18.0835C16.6877 17.9728 17.1193 17.7515 17.4458 17.4194C17.7668 17.0929 17.9826 16.6641 18.0933 16.1328C18.2095 15.6016 18.2676 15.0343 18.2676 14.4312V5.61572ZM5.10254 10.0068C5.10254 9.77441 5.17448 9.58626 5.31836 9.44238C5.46224 9.2985 5.65039 9.22656 5.88281 9.22656H9.23633V5.87305C9.23633 5.64062 9.3055 5.45247 9.44385 5.30859C9.58773 5.15918 9.77035 5.08447 9.9917 5.08447C10.2186 5.08447 10.404 5.15918 10.5479 5.30859C10.6973 5.45247 10.772 5.64062 10.772 5.87305V9.22656H14.1338C14.3607 9.22656 14.5461 9.2985 14.6899 9.44238C14.8338 9.58626 14.9058 9.77441 14.9058 10.0068C14.9058 10.2227 14.8338 10.4025 14.6899 10.5464C14.5461 10.6847 14.3607 10.7539 14.1338 10.7539H10.772V14.1157C10.772 14.3481 10.6973 14.5363 10.5479 14.6802C10.404 14.8241 10.2186 14.896 9.9917 14.896C9.77035 14.896 9.58773 14.8241 9.44385 14.6802C9.3055 14.5308 9.23633 14.3426 9.23633 14.1157V10.7539H5.88281C5.65592 10.7539 5.46777 10.6847 5.31836 10.5464C5.17448 10.4025 5.10254 10.2227 5.10254 10.0068Z" fill="black"/>
    </svg>

  );
};

export {
  Selected,
  SelectedFilled,
  SelectAllDays,
  SelectWeek,
  Hand,
  AutoCreate,
  CopyCalendar,
  NinetyLeft,
  NinetyRight,
  AvailabilityCalendar,
  WorldSearch,
  AvailabilityManagement,
  Shift,
  IosShare,
  IosAddToHome
};
